import { Link } from "../../../types/api";

export function addLocationOriginToUri(uri: string): string {
  return window.location.origin + uri;
}

function extractRelName(link: Link): string {
  return link.rel.split("/").pop() as string;
}

export function findLink(name: string, links: Array<Link>): Link {
  const match = links.find((l) => extractRelName(l) === name);

  if (!match) {
    throw new Error(
      `Link ${name} not found in [${links.map((l) => l.rel).join(",")}]`,
    );
  }

  return match;
}

export function linkExists(name: string, links: Array<Link>): boolean {
  try {
    return findLink(name, links).uri !== undefined;
  } catch (err) {
    return false;
  }
}

export function findURIWithWindowHostname(
  name: string,
  links: Array<Link>,
): string {
  const uri = findLink(name, links).uri;
  const { pathname } = new URL(uri);
  return addLocationOriginToUri(pathname);
}

export const findUriIfExists = (
  name: string,
  links: Array<Link>,
): string | undefined => {
  if (linkExists(name, links)) {
    const uri = findLink(name, links).uri;
    const { pathname } = new URL(uri);
    return addLocationOriginToUri(pathname);
  }

  return undefined;
};
